import type { Permission } from '../entities/permissions';

/** A user with no permissions has not been onboarded yet (partner flow). */
export const isNewUser = (permissions: Permission[]) => {
  return permissions.length === 0;
};

export const hasAllPermissions = (
  granted: Permission[],
  required: Permission[]
) => {
  return required.every((permission) => granted.includes(permission));
};
